import VideoPlayerUpNext from './VideoPlayerUpNext'

export default VideoPlayerUpNext
// eslint-disable-next-line import/export
export * from './VideoPlayerUpNext'
